export default __webpack_public_path__ + "static/media/icon-fire.89f76133.svg";